<template>
    <div class="setting">
        <el-form :model="searchData" size="small" class="el-form__inline">
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-form-item>
                        <el-input v-model="searchData.name" placeholder="公海名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item>
                        <el-button type="primary" plain icon="el-icon-search" @click="SearchSea"
                            >搜索</el-button
                        >
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="card">
            <div class="list" v-loading="seaData.loading.list">
                <div class="list-control t-right">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-circle-plus"
                        @click="DetailSea"
                        >公海</el-button
                    >
                </div>
                <div class="list-table">
                    <el-table :data="seaData.list" stripe style="width: 100%">
                        <el-table-column label="名称" width="240">
                            <template slot-scope="scope">{{ scope.row.name }}</template>
                        </el-table-column>
                        <el-table-column label="跟进回收规则" width="120">
                            <template slot-scope="scope"
                                >{{ scope.row.follow_days || 0 }} 天</template
                            >
                        </el-table-column>
                        <el-table-column label="成交回收规则" width="120">
                            <template slot-scope="scope"
                                >{{ scope.row.order_days || 0 }} 天</template
                            >
                        </el-table-column>
                        <el-table-column label="客户数量" width="120">
                            <template slot-scope="scope"
                                >{{ scope.row.customer_count || 0 }} 人</template
                            >
                        </el-table-column>
                        <el-table-column prop="memo" label="描述"></el-table-column>
                        <el-table-column width="180" fixed="right">
                            <template slot-scope="scope">
                                <div class="t-right">
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DetailSea(scope.row)"
                                        >修改</el-link
                                    >
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="AuthSea(scope.row)"
                                        >权限</el-link
                                    >
                                    <el-divider direction="vertical"></el-divider>
                                    <el-link
                                        type="primary"
                                        :underline="false"
                                        @click="DelSea(scope.row)"
                                        >删除</el-link
                                    >
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="seaData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="seaData.pages.pagesize"
                        :total="seaData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>

        <v-SeaForm :detailParam="componentParam.seaForm" v-if="componentParam.seaForm.visible" />
        <v-ManageForm
            :detailParam="componentParam.manageForm"
            v-if="componentParam.manageForm.visible"
        />
    </div>
</template>

<script>
import SeaForm from '@/components/sea/Form'
import ManageForm from '@/components/manage/Form'
export default {
    components: {
        'v-SeaForm': SeaForm,
        'v-ManageForm': ManageForm
    },
    inject: ['reload'],
    data() {
        return {
            searchData: {
                name: null
            },
            seaData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            },
            componentParam: {
                manageForm: {},
                seaForm: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetSea()
        })
    },
    methods: {
        SearchSea() {
            this.seaData.pages.page = 0
            this.GetSea()
        },
        // 公海列表
        GetSea() {
            this.seaData.loading.list = true
            this.$request({
                url: '/api/v1/customer_sea',
                data: {
                    ...this.seaData.pages
                }
            }).then(res => {
                this.seaData.loading.list = false
                if (!res.status) {
                    this.seaData.list = res.data.list
                    this.seaData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.seaData.pages.pagesize = val
            this.GetSea()
        },
        GetCurrent(val) {
            this.seaData.pages.page = val
            this.GetSea()
        },
        // 修改
        DetailSea(row) {
            this.componentParam.seaForm = {
                visible: true,
                row: row.id
                    ? {
                          id: row.id
                      }
                    : {}
            }
        },
        // 权限
        AuthSea(row) {
            this.componentParam.manageForm = {
                visible: true,
                row: {
                    table_name: 'customer_sea',
                    key_id: row.id
                }
            }
        },
        // 删除
        DelSea(row) {
            this.$confirm('此操作将永久删除当前数据, 是否继续?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.seaData.loading.list = true
                    this.$request({
                        url: '/api/v1/customer_sea_del',
                        params: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/card.less';
@import '~@/assets/css/list.less';
</style>
